import { DocumentoComercialAsociadoReadingDtoProps } from "./DTOs/DocumentoComercialAsociadoReadingDto"
import { FicheroReadingDtoProps } from "./DTOs/FicheroReadingDto"
import { PresupuestoReadingDtoProps } from "./DTOs/PresupuestoReadingDto"
import { PresupuestoReadingFiltersDtoProps } from "./DTOs/PresupuestoReadingFiltersDto"
import { PresupuestoReadingSimpleDtoProps } from "./DTOs/PresupuestoReadingSimpleDto"
import { ValidacionDocumentoReadingDtoProps } from "./DTOs/ValidacionDocumentoReadingDto"

export const presupuestoByFilterAdapter = (
  presupuesto: PresupuestoReadingFiltersDtoProps
): PresupuestoReadingFiltersDtoProps => {
  return {
    id: presupuesto.id,
    divisa: presupuesto.divisa,
    estadoRevisionActual: presupuesto.estadoRevisionActual,
    fechaEmision: presupuesto.fechaEmision,
    importe: presupuesto.importe,
    motivo: presupuesto.motivo,
    nifLibrado: presupuesto.nifLibrado,
    nifLibrador: presupuesto.nifLibrador,
    numero: presupuesto.numero,
    numeroFicherosAdjuntos: presupuesto.numeroFicherosAdjuntos,
    paisLibrado: presupuesto.paisLibrado,
    paisLibrador: presupuesto.paisLibrador,
    razonSocialLibrado: presupuesto.razonSocialLibrado,
    razonSocialLibrador: presupuesto.razonSocialLibrador,
    serie: presupuesto.serie,
    tipoDocumento: presupuesto.tipoDocumento,
  }
}

export const presupuestoByIdSimple = (
  presupuesto: PresupuestoReadingSimpleDtoProps
): PresupuestoReadingSimpleDtoProps => {
  return {
    id: presupuesto.id,
    divisa: presupuesto.divisa,
    empresa: presupuesto.empresa,
    estadoRevisionActual: presupuesto.estadoRevisionActual,
    fechaEmision: presupuesto.fechaEmision,
    fechaVencimiento: presupuesto.fechaVencimiento,
    importe: presupuesto.importe,
    motivo: presupuesto.motivo,
    serieNumero: presupuesto.serieNumero,
    tipoDocumento: presupuesto.tipoDocumento,
  }
}

export const presupuestoFicherosAdjuntosAdapter = (
  archivo: FicheroReadingDtoProps
): FicheroReadingDtoProps => ({
  id: archivo.id,
  esDocumentoImportado: archivo.esDocumentoImportado,
  extension: archivo.extension,
  mediaType: archivo.mediaType,
  nombre: archivo.nombre,
  ruta: archivo.ruta,
  tamañoEnBytes: archivo.tamañoEnBytes,
  tipo: archivo.tipo,
})

export const presupuestoById = (
  presupuesto: PresupuestoReadingDtoProps
): PresupuestoReadingDtoProps => {
  return {
    id: presupuesto.id,
    estadoRevisionActual: presupuesto.estadoRevisionActual,
    tipoDocumento: presupuesto.tipoDocumento,
    configuracion: presupuesto.configuracion,
    articuloDocumentos: presupuesto.articuloDocumentos,
    cliente: presupuesto.cliente,
    descuento: presupuesto.descuento,
    diasPago: presupuesto.diasPago,
    divisa: presupuesto.divisa,
    documentosAjustesPorDefecto: presupuesto.documentosAjustesPorDefecto,
    documentosComercialesAsociados: presupuesto.documentosComercialesAsociados,
    fechaEmision: presupuesto.fechaEmision,
    fechaOperacion: presupuesto.fechaOperacion,
    formaPago: presupuesto.formaPago,
    importe: presupuesto.importe,
    impuestoRetenido: presupuesto.impuestoRetenido,
    libradoId: presupuesto.libradoId,
    libradorId: presupuesto.libradorId,
    logo: presupuesto.logo,
    numero: presupuesto.numero,
    numeroAdjuntos: presupuesto.numeroAdjuntos,
    observaciones: presupuesto.observaciones,
    origen: presupuesto.origen,
    serie: presupuesto.serie,
    tarifaImpuesto: presupuesto.tarifaImpuesto,
    tipoDocumentoComercial: presupuesto.tipoDocumentoComercial,
    totalRetenido: presupuesto.totalRetenido,
    usuario: presupuesto.usuario,
  }
}

export const presupuestoDocAsociadosAdapter = (
  doc: DocumentoComercialAsociadoReadingDtoProps
): DocumentoComercialAsociadoReadingDtoProps => ({
  id: doc?.id,
  numero: doc?.numero,
  serie: doc?.serie,
  tipoDocumento: doc?.tipoDocumento,
})

export const presupuestoDocumentoPendienteValidacionAdapter = (
  documento: ValidacionDocumentoReadingDtoProps
): ValidacionDocumentoReadingDtoProps => ({
  id: documento.id,
  autovalidacion: documento.autovalidacion,
  etapas: documento.etapas,
  rango: documento.rango,
  tipoDocumento: documento.tipoDocumento,
  todosLosRangos: documento.todosLosRangos,
})
